import React, { ElementType, FC, HTMLAttributes } from 'react';
import styles from './styles.module.css';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  as?: ElementType;
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
}

export const Container: FC<ContainerProps> = ({
  children,
  as: Tag = 'div',
  xl,
  lg,
  md,
  sm,
  className,
  style,
  ...rest
}) => {
  const classes = [
    styles.container,
    xl && styles.containerXl,
    lg && styles.containerLg,
    md && styles.containerMd,
    sm && styles.containerSm,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} style={{ ...style }} {...rest}>
      {children}
    </Tag>
  );
};
